// @flow
import React, { createContext, useContext, useState } from 'react';
import type { Node } from 'react';

type Context = $ReadOnly<{
    activeId?: number,
    setActiveId: (id: number) => void
}>;

const OptionsContext = createContext<Context>({});

type Props = $ReadOnly<{
    children: Node
}>;

export const OptionsProvider = ({ children }: Props) => {
    const [activeId, setActiveId] = useState();

    const context = {
        activeId,
        setActiveId
    };

    return (
        <OptionsContext.Provider value={context}>
            {children}
        </OptionsContext.Provider>
    );
};


let _uid = 1;
export const useUid = () => {
    const [uid] = useState(() => _uid++);
    return uid;
};

export const useOptionsContext = () => useContext(OptionsContext);

export const useActiveId = () => {
    const context = useOptionsContext();
    return context.activeId;
};

export const useSetActiveId = () => {
    const context = useOptionsContext();
    return context.setActiveId;
};
